const PACKAGE_UPGRADING = {
  PAGE_TITLE: ' تمدید یا ارتقا پکیج | رایچت',

  HEADING_TITLE: 'تمديد يا ارتقا پكيج',
  HEADING_SUBTITLE:
    'شما می‌توانید با انتخاب نوع و زمان پکیج و ادامه فرآیند پرداخت، اکانت خود را شارژ نمایید.',

  CHOOSE_PACKAGE: 'انتخاب پکیج',
  ACTIVE_PACKAGE: 'پکیج فعال',

  BASE: 'پایه',
  COMMERICAL: 'تجاری',
  PREMIUM: 'پریمیوم',
  ALL_FEATURES_OF_PACKAGE: 'تمامی امکانات پکیج ',

  MONTHLY: 'ماهانه',
  QUARTERLY: 'سه ماهه',
  YEARLY: 'سالانه',
  TRIENNIAL: 'سه ساله',
  // UNIT: 'هزار تومان',
  UNIT: 'تومان',
  TOOMAN: 'تومان',

  SEND_OFFICIAL_INVOICE: 'ارسال پستی فاکتور',

  CONTINUE_PURCHASE: 'ادامه فرايند خريد',
  CHECK_AND_CONTINUE_PURCHASE: 'بررسی و ادامه فرایند خرید',

  ACCOUNT_INFO: 'اطلاعات حساب',

  PACKAGE: 'پکیج',
  DURATION: 'دوره پرداخت',
  POSTING: 'ارسال پستی',
  TAX: 'مالیات',
  USE_CREDIT: 'استفاده از اعتبار',
  PAYABLE: 'قابل پرداخت',
  DISCOUNT_CODE: 'كد تخفيف',
  DISCOUNT_CODE_PERCENT: 'تخفیف',
  CHECK: 'بررسی',
  ENTER_DISCOUNT_CODE: 'كد تخفيف را وارد كنيد',
  DISCOUNT_CODE_APPLIED: 'كد تخفيف #code# اعمال شد',
  DISCOUNT_CODE_APPLIED_PURE: 'كد تخفيف اعمال شد',
  CANCEL: 'لغو',
  CANCEL_CODE: 'لغو کد',

  PRICE_BEFORE_DISCOUNT: 'مبلغ بدون تخفیف',

  PACKAGE_PRICE: 'قیمت پکیج',

  CHOOSE_HOW_TO_RENEWAL: 'انتخاب نحوه تمديد',
  CHECK_USER_INFO_HEADER: 'بررسی اطلاعات',
  INFO_EDIT_BTN: 'ویرایش',
  SERVICE: 'سرويس',

  NATIONAL_CODE: 'کدملی',
  PROVINCE: 'استان',
  CITY: 'شهر',
  PHONE: 'شماره موبایل',
  ADDRESS: 'آدرس',
  COUNTRY: 'کشور',
  POSTAL_CODE: 'کدپستی',

  DOWNLOAD_FACTOR_LATER:
    'نیازی به ارسال فاکتور فیزیکی نیست. بعد از پرداخت میتوانید فاکتور رسمی صورتحساب خودتون رو از بخش صورتحساب ها از لینک زیر دانلود کنید.',

  SERVICE_MANUAL_RENEWAL: 'تمديد عادی سرويس',
  SERVICE_AUTO_RENEWAL: 'به صورت خودكار هر ماه از حسابم برداشت شود',
  // SERVICE_AUTO_RENEWAL_DESCRIPTION: ` در این نوع اشتراک دیگر نیازی نیست به صورت ماهیانه اشتراک
  //   خریداری کنید، مبلغ اشتراک به صورت خودکار از حساب شما کسر و
  //   اشتراک شما تمدید خواهد شد.`,
  SERVICE_AUTO_RENEWAL_DESCRIPTION:
    'با انتخاب این گزینه سرویس شما به صورت اتوماتیک در پایان دوره پرداخت میشود',
  REDIRECT_TO_PAYMENT_GATEWAY: 'انتقال به درگاه پرداخت',
  GO_TO_PREV_STEP: 'بازگشت به مرحله قبل',

  PAYMENT_SUCCESS_CARD_TITLE: 'پرداخت با موفقیت انجام شد',
  PAYMENT_FAIL_CARD_TITLE: 'پرداخت ناموفق',
  PAYMENT_RESULT_INVOICE_ID_LABEL: 'شماره فاکتور',
  PAYMENT_RESULT_ID_LABEL: 'شناسه پرداخت',
  PAYMENT_RESULT_TOKEN_LABEL: 'توکن',
  PAYMENT_RESULT_BACK_LINK_TEXT: 'بازگشت به صفحه پرداخت',
  PAYMENT_RESULT_DETAILS_TITLE: 'جزئیات تراکنش',
  BUY_PACKAGE: 'خرید پکیج',
  COMPARE: 'مقایسه امکانات',

  SELECTED_PACKAGE: 'پکیج انتخابی',
  USE_DISCOUNT: 'کد تخفیف',
  POPULAR: 'پرطرفدار',
  SPECIAL_DISCOUNT_FOR_NEW_BUSINESS: 'ویژه کسب و کار های در حال رشد',
};

export default PACKAGE_UPGRADING;
